import Reveal from "@/components/escape21/Reveal";
import { REEL_PRINTS } from "./constants";

const ReelsGrid = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-6xl">
      <Reveal className="text-center">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
          reels em destaque
        </span>
        <h2 className="mx-auto mt-4 max-w-2xl text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          print por print, os <span className="e21-serif text-green-400">números reais</span> de cada reel.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/55 sm:text-lg">
          alcance, curtidas, salvamentos e compartilhamentos direto do instagram.
          nada editado.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-4">
        {REEL_PRINTS.map((src, i) => (
          <Reveal key={src} delay={(i % 4) * 60}>
            <img
              src={src}
              alt={`insight de reel ${i + 1}`}
              loading="lazy"
              className="w-full rounded-xl border border-white/10 bg-white/5 transition-transform duration-300 hover:scale-[1.03]"
            />
          </Reveal>
        ))}
      </div>

      <Reveal delay={120} className="mt-12 text-center">
        <p className="text-base italic text-white/50 sm:text-lg">
          …e muitos outros acima de 50k, 60k e 80k de views.
        </p>
      </Reveal>
    </div>
  </section>
);

export default ReelsGrid;
